import { CheckCircleFillIcon, Tag, Text } from 'ui';

const CommunityJoinedStatusBadge = () => (
  <Tag color="bg-none" icon={<CheckCircleFillIcon size="small" type="success" />}>
    <Text>Joined</Text>
  </Tag>
);

export default CommunityJoinedStatusBadge;
